import React, { useState } from "react";
import SettingsLayout from "../../../layouts/SettingsLayout";
import SettingsHeading from "../../../settings/SettingsHeading";
import Recruiter from "../../../../apiResources/Recruiter";
import RecruiterUser from "../../../../apiResources/RecruiterUser";
import Employer from "../../../../apiResources/Employer";
import EmployerUser from "../../../../apiResources/EmployerUser";
import Loader from "../../../library/Loader";
import Divider from "../../../library/Divider";
import CompanyNameSettingsOption from "../../../settings/CompanyNameSettingsOption";
import PhoneNumberSettingsOption from "../../../settings/PhoneNumberSettingsOption";
import WebsiteAddressSettingsOption from "../../../settings/WebsiteAddressSettingsOption";
import NumberOfEmployeesSettingsOption from "../../../settings/NumberOfEmployeesSettingsOption";
import CompanyDescriptionSettingsOption from "../../../settings/CompanyDescriptionSettingsOption";
import LogoSettingsOption from "../../../settings/LogoSettingsOption";
import RecruiterTenure from "../../../settings/RecruiterTenure";

const Overview = (props: Props) => {
  const [editFocus, setEditFocus] = useState<string>(null);
  const { user, company } = props;

  const isDisabled = (value) => Boolean(editFocus) && editFocus !== value;
  const isEditing = (value) => Boolean(editFocus) && editFocus === value;

  if (!user || !company) {
    return (
      <SettingsLayout>
        <Loader />
      </SettingsLayout>
    );
  }

  return (
    <SettingsLayout user={user} company={company}>
      <SettingsHeading>Overview</SettingsHeading>

      <CompanyNameSettingsOption
        user={user}
        company={company}
        disabled={isDisabled("name")}
        onEditStart={() => setEditFocus("name")}
        isEditing={isEditing("name")}
        onEditComplete={() => setEditFocus(null)}
      />
      <Divider />
      <LogoSettingsOption user={user} company={company} />
      <Divider />
      <WebsiteAddressSettingsOption
        user={user}
        company={company}
        disabled={isDisabled("website")}
        onEditStart={() => setEditFocus("website")}
        isEditing={isEditing("website")}
        onEditComplete={() => setEditFocus(null)}
      />
      <Divider />
      <RecruiterTenure 
       user={user}
        company={company}
        disabled={isDisabled("existingSince")}
        onEditStart={() => setEditFocus("existingSince")}
        isEditing={isEditing("existingSince")}
        onEditComplete={() => setEditFocus(null)}
      />
      <Divider />
      {user.isEmployer && (
        <>
          <PhoneNumberSettingsOption
            user={user as EmployerUser}
            company={company as Employer}
            disabled={isDisabled("phoneNumber")}
            onEditStart={() => setEditFocus("phoneNumber")}
            isEditing={isEditing("phoneNumber")}
            onEditComplete={() => setEditFocus(null)}
          />
          <Divider />
          <NumberOfEmployeesSettingsOption
            user={user as EmployerUser}
            company={company as Employer}
            disabled={isDisabled("numberOfEmployees")}
            onEditStart={() => setEditFocus("numberOfEmployees")}
            isEditing={isEditing("numberOfEmployees")}
            onEditComplete={() => setEditFocus(null)}
          />
          <Divider />
          <CompanyDescriptionSettingsOption
            user={user as EmployerUser}
            company={company as Employer}
            disabled={isDisabled("description")}
            onEditStart={() => setEditFocus("description")}
            isEditing={isEditing("description")}
            onEditComplete={() => setEditFocus(null)}
          />
        </>
      )}
    </SettingsLayout>
  );
};

type Props = {
  user: RecruiterUser | EmployerUser;
  company: Employer | Recruiter;
};

export default Overview;
